import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DTypeFormSelectField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { firstValueFrom, map, Observable, startWith, Subject } from 'rxjs';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { CompanyService } from '../../../company/company.service';
import { LocalizePipe } from '../../../pipes/localize.pipe';
import { UserService } from '../../../user/user.service';
import { Utils } from '../../../utils/utils';

@Component({
    selector: 'user-select-field',
    templateUrl: 'user-select-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeUserSelectFieldComponent implements DTypeFormFieldComponent, OnInit, OnDestroy {

    @Input() field: DTypeFormSelectField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    searchCtrl = new FormControl();
    options: any[];
    options$: Observable<any[]>;

    private _unsubscribeAll = new Subject<void>();

    constructor(
        private companyService: CompanyService,
        private localize: LocalizePipe,
        private usersService: UserService,
    ) { }

    async ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }

        // TODO process when field.control is enabled/disabled
        if (this.field.control.disabled) {
            this.searchCtrl.disable();
        }
        this.options = await firstValueFrom(this.usersService.retrieveCompanyUser(this.companyService.structureCompanyId, 'displayName'));

        this.options$ = this.searchCtrl.valueChanges.pipe(
            startWith(''),
            map((value: string) => this.options.map((opt) => {
                opt.hide = !Utils.removeAccents(this.localize.transform(opt.displayName)).toLowerCase().includes(Utils.removeAccents(value).toLowerCase());
                return opt;
            }))
        );
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
